export  const menuItems = [
    {
        id: 1,
        label: "Početna",
        icon: "esei icon-home esei-default",
        badge: {
            variant: "info",
            text: "menuitems.dashboard.badge"
        },
        link: "/",
        isTitle: false,
        menu : false,
        logout: false,
        login:false,
        link2:''
    },
    {
        id: 2,
        label: "Glavni meni",
        isTitle: true,
        menu : false,
        logout: false,
        login:false,
        link2:''

    },
    
    {
        id: 3,
        label: "Meni",
        icon: "esei icon-grip-solid esei-lg",
        badge: {
            variant: "info",
            text: "menuitems.dashboard.badge"
        },
        link: "/korisnicki-profil/meni",
        link2:'',
        isTitle: false,
        menu : false,
        logout: false

    },
    {
        id: 4,
        label: "Komponente",
        link2:'',
        isTitle: true,
        menu : false,
        logout: false
    },
    {
       id: 55,
       label: "Registruj tezgu",
       icon: "esei icon-store-solid",
       link: "/korisnicki-profil/tezga-registracija",
       link2:'/korisnicki-profil/tezga-registracija',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
       badge: {
           variant: "warning",
           text: "menuitems.chat.badge"
       }
   },
    {
       id: 5,
       label: "Dodaj novi oglas",
       icon: "esei icon-folder-plus-solid",
       link: "/korisnicki-profil/novi-oglas",
       link2:'/korisnicki-profil/novi-oglas',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
       badge: {
           variant: "warning",
           text: "menuitems.chat.badge"
       }
   },
   {
       id: 6,
       label: "Aktivni oglasi",
       icon: "esei icon-folder-open",
       link: "/korisnicki-profil/aktivni-oglasi",
       link2:'/korisnicki-profil/aktivni-oglasi',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
       badge: {
           variant: "warning",
           text: "menuitems.chat.badge"
       }
   },
   {
       id: 7,
       label: "Neaktivni oglasi",
       icon: "esei icon-folder-minus-solid",
       link: "/korisnicki-profil/neaktivni-oglasi",
       link2:'/korisnicki-profil/neaktivni-oglasi',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
       badge: {
           variant: "warning",
           text: "menuitems.chat.badge"
       }
   },
   {
       id: 8,
       label: "Praćenje oglasa",
       icon: "esei icon-heart",
       link: "/korisnicki-profil/pracenje",
       link2:'/korisnicki-profil/pracenje',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
       badge: {
           variant: "warning",
           text: "menuitems.chat.badge"
       }
   },
   
//    {
//        id: 9,
//        label: "Statistika cena",
//        icon: "fas fa-chart-area",
//        link: "/korisnicki-profil/statistika/meni",
//        link2:'/korisnicki-profil/statistika/meni',
//        isTitle: false,
//        menu : true,
//        logout: false,
//        login:false,
//        subItems: [
//            {
//                id: 1,
//                label: "Mesec",
//                link: "/korisnicki-profil/statistika/mesec",
//                parentId: 9

//            },
//            {
//                id: 2,
//                label: "Nedelja",
//                link: "/korisnicki-profil/statistika/nedelja",
//                parentId: 9
               
//            },
//        ]
//    },
 {
       id: 9,
       label: "Poruke",
       icon: "esei icon-envelope-solid",
        link: "/korisnicki-profil/poruke/prikaz-oglasa",
       link2:'/korisnicki-profil/poruke/prikaz-oglasa',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
      
   },
   {
       id: 146,
       label: "Obaveštenja",
       icon: "esei icon-bell-solid",
        link: "/korisnicki-profil/obavestenja",
       link2:'/korisnicki-profil/obavestenja',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
      
   },
   {
       id: 14,
       label: "Ocene",
       icon: "esei icon-ranking-star-solid",
        link: "/korisnicki-profil/ocene",
       link2:'/korisnicki-profil/ocene',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
      
   },
   {
       id: 15,
       label: "Pratim",
       icon: "esei icon-angle-right-solid",
        link: "/korisnicki-profil/pratim",
       link2:'/korisnicki-profil/pratim',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
      
   },
   {
       id: 16,
       label: "Pratioci",
       icon: "esei icon-angle-right-solid",
        link: "/korisnicki-profil/pratioci",
       link2:'/korisnicki-profil/pratioci',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
      
   },
   {
       id: 17,
       label: "Profil",
       icon: "esei icon-user-solid esei-default",
       link: "/korisnicki-profil/profil",
       link2:'/korisnicki-profil/profil',
       isTitle: false,
       menu : true,
       logout: false,
       login:false,
       badge: {
           variant: "warning",
           text: "menuitems.chat.badge"
       }
   },
   {
       id: 18,
       label: "Odjavi se",
       icon: "esei icon-chevron-circle-left",
       link: "/cms/img-del/img-del",
       link2:'/cms/img-del/img-del',
       isTitle: false,
       menu : false,
       logout: true,
       login:false
       
   },
   {
       id: 19,
       label: "Prijavi se",
       icon: "esei icon-circle-right-solid",
       link: "/login",
       link2:'/login',
       isTitle: false,
       menu : false,
       logout: false,
       login: true
       
   },
    
]
